import { render, staticRenderFns } from "./UninvoicedJobs.vue?vue&type=template&id=4792251a&scoped=true"
import script from "./UninvoicedJobs.vue?vue&type=script&lang=ts"
export * from "./UninvoicedJobs.vue?vue&type=script&lang=ts"
import style0 from "./UninvoicedJobs.scss?vue&type=style&index=0&id=4792251a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4792251a",
  null
  
)

export default component.exports